import React, { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { Shield, X } from 'lucide-react';
import api from '../lib/api';

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = async () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
    try {
      await api.post('/gdpr/consent', { consent_type: 'cookies', consented: true });
    } catch { /* non-blocking */ }
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
    try {
      api.post('/gdpr/consent', { consent_type: 'cookies', consented: false });
    } catch { /* non-blocking */ }
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9999] p-4 bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-700 shadow-lg"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Shield className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5 sm:mt-0" />
        <div className="flex-1 text-sm text-slate-600 dark:text-slate-300">
          We use essential cookies and local storage for authentication and preferences.
          No third-party tracking. See our{' '}
          <Link to="/privacy-policy" className="text-blue-600 dark:text-blue-400 underline">
            Privacy Policy
          </Link>{' '}
          for details.
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <Button variant="outline" size="sm" onClick={handleDecline} data-testid="cookie-decline-btn">
            Decline
          </Button>
          <Button size="sm" onClick={handleAccept} data-testid="cookie-accept-btn">
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};
